// In App.jsx
import React, { useState } from 'react';
import './App.css';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero';
import Join from './components/Join/Join';
import Login from './components/Login/Login';
import Plans from './components/Plans/Plans';
import Programs from './components/Programs/Programs';
import Reasons from './components/Reasons/Reasons';
import Signup from './components/Signup/Signup';
import Testimonials from './components/Testimonials/Testimonials';

function App() {
    const [showLogin, setShowLogin] = useState(false); // Changed to showLogin
    const [showSignup, setShowSignup] = useState(false); // Changed to showSignup
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [users, setUsers] = useState([]);
    const [loginError, setLoginError] = useState('');

    const handleLoginClick = () => {  // Changed to handleLoginClick
        setShowLogin(true); // Show login modal
    };

    const handleSignupClick2 = () => { // Renamed to handleSignupClick2
        setShowSignup(true);
    };

    const handleSignupClose = () => {
        setShowSignup(false);
    };

    const handleLoginClose = () => {
        setShowLogin(false);
        setLoginError(''); // Clear any login errors when closing the login modal
    };

    const handleLoginSuccess = (email) => {
        setIsLoggedIn(true);
        setUserEmail(email);
        setShowLogin(false);
    };

    const handleSignupSuccess = (newUser) => {
        setUsers([...users, newUser]);
        setShowSignup(false);
    };

    return (
        <div className="App">
            {!isLoggedIn ? (
                <>
                    <Hero onLoginClick={handleLoginClick} userEmail={userEmail} /> 
                    {showLogin && (
                        <div className="modal">
                            <div className="modal-content">
                                <Login
                                    onClose={handleLoginClose}
                                    onLoginSuccess={handleLoginSuccess}
                                    users={users}
                                    setLoginError={setLoginError}
                                    loginError={loginError}
                                    onSignupClick={handleSignupClick2}
                                />
                            </div>
                        </div>
                    )}
                    {showSignup && (
                        <div className="modal">
                            <div className="modal-content">
                                <Signup
                                    onClose={handleSignupClose}
                                    onLoginClick={handleLoginClick}
                                    onSignupSuccess={handleSignupSuccess}
                                />
                                
                            </div>
                            
                        </div>
                    )}
                </>
            ) : (
                <>
                    
                    <Hero userEmail={userEmail} />
                    <Programs />
                    <Reasons />
                    <Plans />
                    <Testimonials />
                    <Join />
                    <Footer />
                </>
            )}
        </div>
    );
}

export default App;
